/**
 * @generated SignedSource<<bd3bac276de1976a5141b4a1857b0a70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "folderId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "threadId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "withoutThreadId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "folderId",
    "variableName": "folderId"
  }
],
v2 = {
  "kind": "Variable",
  "name": "threadId",
  "variableName": "threadId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "withoutThreadId",
    "variableName": "withoutThreadId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "folderId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wChannelIds",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationIcon",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v14 = [
  (v9/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v5/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userIds",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationDescription",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationBuild",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "IFrameContext",
  "kind": "LinkedField",
  "name": "iframeContext",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payload",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedContext",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contextToken",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headers",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modalSchema",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modalView",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modalWidth",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wAppId",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wUserId",
  "storageKey": null
},
v34 = [
  {
    "kind": "Literal",
    "name": "assigned",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  {
    "items": [
      {
        "kind": "Literal",
        "name": "folderIds.0",
        "value": "main"
      }
    ],
    "kind": "ListValue",
    "name": "folderIds"
  },
  {
    "kind": "Literal",
    "name": "onlyUnread",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  },
  {
    "kind": "Literal",
    "name": "sortBy",
    "value": "lastChatAt"
  },
  {
    "kind": "Literal",
    "name": "sortOrder",
    "value": "desc"
  }
],
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "threadId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wMemberId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wChannelId",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "etag",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadCount",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupChat",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalProfile",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePicUrl",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "UserEmail",
  "kind": "LinkedField",
  "name": "email",
  "plural": false,
  "selections": [
    (v53/*: any*/)
  ],
  "storageKey": null
},
v55 = [
  (v33/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v54/*: any*/),
  (v5/*: any*/)
],
v56 = [
  (v2/*: any*/)
],
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alias",
  "storageKey": null
},
v58 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 0
  },
  {
    "kind": "Literal",
    "name": "last",
    "value": 10
  }
],
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePic",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InboxQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "Inbox_userViewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Folders_userViewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Threads_userViewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "GlobalThreads_userViewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CallHistoryList_userViewer"
          },
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "ConversationHistory_userViewer"
          },
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "MemberContainer_userViewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "navHintViewer",
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Literal",
                "name": "withoutNavHint",
                "value": true
              }
            ],
            "kind": "FragmentSpread",
            "name": "Inbox_navHintViewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "folderThreadsViewer",
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "Inbox_folderThreadsViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InboxQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Configuration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberConfig",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1000
              },
              {
                "kind": "Literal",
                "name": "unreadOnly",
                "value": true
              }
            ],
            "concreteType": "MentionConnection",
            "kind": "LinkedField",
            "name": "mentions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MentionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Mention",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "mentions(first:1000,unreadOnly:true)"
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folder",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Channel",
                "kind": "LinkedField",
                "name": "wChannels",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "default",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Integration",
            "kind": "LinkedField",
            "name": "folderActions",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WChannel",
                "kind": "LinkedField",
                "name": "channel",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v22/*: any*/),
                  (v9/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WEnvironment",
                    "kind": "LinkedField",
                    "name": "environments",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "webhooks",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WebhookV2",
                        "kind": "LinkedField",
                        "name": "webhooksV2",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CustomAction",
                "kind": "LinkedField",
                "name": "customActions",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v22/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modalHeight",
                    "storageKey": null
                  },
                  (v31/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disableNotifications",
            "storageKey": null
          },
          (v32/*: any*/),
          (v33/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Folder",
            "kind": "LinkedField",
            "name": "folders",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unreadThreadCount",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v34/*: any*/),
            "concreteType": "ThreadConnection",
            "kind": "LinkedField",
            "name": "threads",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ThreadEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Thread",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Folder",
                        "kind": "LinkedField",
                        "name": "folder",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Channel",
                        "kind": "LinkedField",
                        "name": "wChannel",
                        "plural": false,
                        "selections": (v14/*: any*/),
                        "storageKey": null
                      },
                      (v38/*: any*/),
                      (v31/*: any*/),
                      (v39/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastChatAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastMessage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastReadAt",
                        "storageKey": null
                      },
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Member",
                        "kind": "LinkedField",
                        "name": "member",
                        "plural": false,
                        "selections": [
                          (v41/*: any*/),
                          (v42/*: any*/),
                          (v43/*: any*/),
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "inboxProfile",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/),
                              (v46/*: any*/),
                              (v9/*: any*/),
                              (v47/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "newFromInboxAction",
                            "storageKey": null
                          }
                        ]
                      },
                      (v48/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v49/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v50/*: any*/),
                  (v51/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "threads(assigned:false,first:30,folderIds:[\"main\"],onlyUnread:false,search:\"\",sortBy:\"lastChatAt\",sortOrder:\"desc\")"
          },
          {
            "alias": null,
            "args": (v34/*: any*/),
            "filters": [
              "search",
              "folderIds",
              "wChannelIds",
              "assigned",
              "onlyUnread"
            ],
            "handle": "connection",
            "key": "Threads_threads",
            "kind": "LinkedHandle",
            "name": "threads"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "users",
            "plural": true,
            "selections": (v55/*: any*/),
            "storageKey": null
          },
          {
            "condition": "withoutThreadId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v56/*: any*/),
                "concreteType": "Thread",
                "kind": "LinkedField",
                "name": "thread",
                "plural": false,
                "selections": [
                  (v35/*: any*/),
                  (v40/*: any*/),
                  (v31/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Folder",
                    "kind": "LinkedField",
                    "name": "folder",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v15/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "users",
                        "plural": true,
                        "selections": [
                          (v33/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v54/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Channel",
                            "kind": "LinkedField",
                            "name": "channels",
                            "plural": true,
                            "selections": [
                              (v37/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Member",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v5/*: any*/),
                      (v43/*: any*/),
                      (v44/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfile",
                        "kind": "LinkedField",
                        "name": "inboxProfile",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v9/*: any*/),
                          (v47/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "website",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "company",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DOB",
                            "kind": "LinkedField",
                            "name": "dob",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "date",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "month",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "year",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "gender",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Phone",
                            "kind": "LinkedField",
                            "name": "phones",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "number",
                                "storageKey": null
                              },
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Email",
                            "kind": "LinkedField",
                            "name": "emails",
                            "plural": true,
                            "selections": [
                              (v53/*: any*/),
                              (v57/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "addresses",
                            "plural": true,
                            "selections": [
                              (v57/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "line1",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "line2",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "city",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "state",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "country",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "zip",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "liveChat",
                        "storageKey": null
                      },
                      (v36/*: any*/),
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Channel",
                        "kind": "LinkedField",
                        "name": "wChannel",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v18/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v32/*: any*/),
                      (v4/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "content",
                            "storageKey": null
                          },
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "authorId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              (v54/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v38/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v38/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  (v36/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Channel",
                    "kind": "LinkedField",
                    "name": "wChannel",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "environments",
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SupportedMediaTypes",
                        "kind": "LinkedField",
                        "name": "supportedMediaTypes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FileType",
                            "kind": "LinkedField",
                            "name": "audio",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "codec",
                                "storageKey": null
                              },
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EvaluatedRoleBasedConfig",
                        "kind": "LinkedField",
                        "name": "evaluatedRoleBasedConfig",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "SEND_MESSAGE_ALL",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "SEND_ATTACHMENT",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "SEND_AUDIO",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "TRANSFER_TO_UNASSOCIATED_FOLDERS",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "inputActions",
                    "plural": true,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CustomAction",
                        "kind": "LinkedField",
                        "name": "customActions",
                        "plural": true,
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v22/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v31/*: any*/),
                          (v23/*: any*/),
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "View",
                    "kind": "LinkedField",
                    "name": "views",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v31/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "placements",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "context",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "for",
                        "value": [
                          "BOT",
                          "MEMBER"
                        ]
                      }
                    ],
                    "concreteType": "ResourceTemplate",
                    "kind": "LinkedField",
                    "name": "resourceTemplates",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "preview",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "replyToPreview",
                        "storageKey": null
                      },
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "for",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "resourceTemplates(for:[\"BOT\",\"MEMBER\"])"
                  },
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserEmail",
                        "kind": "LinkedField",
                        "name": "email",
                        "plural": false,
                        "selections": [
                          (v53/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "verified",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v45/*: any*/),
                      (v46/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "concreteType": "ChatConnection",
                    "kind": "LinkedField",
                    "name": "chats",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChatEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Chat",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v35/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "messageEvent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "replyToMessageEvent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "deliveredAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "failedAt",
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sentAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "from",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "internal",
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "error",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "mentions",
                                "plural": true,
                                "selections": (v55/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agent",
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "icon",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v59/*: any*/),
                                  (v54/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v42/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "clientMutationId",
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v48/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v49/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v51/*: any*/),
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "chats(first:0,last:10)"
                  },
                  {
                    "alias": null,
                    "args": (v58/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "ConversationHistory_chats",
                    "kind": "LinkedHandle",
                    "name": "chats"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v56/*: any*/),
                "concreteType": "Folder",
                "kind": "LinkedField",
                "name": "foldersForThread",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v56/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "usersForThread",
                "plural": true,
                "selections": [
                  (v33/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v59/*: any*/),
                  (v54/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": "navHintViewer",
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "folderThreadsViewer",
        "args": null,
        "concreteType": "UserScope",
        "kind": "LinkedField",
        "name": "userViewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "folderIds.0",
                    "variableName": "folderId"
                  }
                ],
                "kind": "ListValue",
                "name": "folderIds"
              }
            ],
            "concreteType": "ThreadConnection",
            "kind": "LinkedField",
            "name": "threads",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v50/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "091cf9bac3222136b58fc0271417f0b4",
    "id": null,
    "metadata": {},
    "name": "InboxQuery",
    "operationKind": "query",
    "text": "query InboxQuery(\n  $folderId: ID\n  $threadId: ID!\n  $withoutThreadId: Boolean!\n) {\n  userViewer {\n    ...Inbox_userViewer_anm0i\n    ...Folders_userViewer\n    ...Threads_userViewer\n    ...GlobalThreads_userViewer\n    ...CallHistoryList_userViewer\n    ...ConversationHistory_userViewer_1f9ovh\n    ...MemberContainer_userViewer_1f9ovh\n    id\n  }\n  navHintViewer: userViewer {\n    ...Inbox_navHintViewer_45Y6Ci\n    id\n  }\n  folderThreadsViewer: userViewer {\n    ...Inbox_folderThreadsViewer_anm0i\n    id\n  }\n}\n\nfragment CallHistoryList_userViewer on UserScope {\n  id\n}\n\nfragment ConversationHistory_userViewer_1f9ovh on UserScope {\n  users {\n    wUserId\n    firstName\n    lastName\n    email {\n      email\n    }\n    id\n  }\n  wUserId\n  thread(threadId: $threadId) @skip(if: $withoutThreadId) {\n    threadId\n    unreadCount\n    title\n    folderId\n    folder {\n      wChannelIds\n      isPrivate\n      folderId\n      name\n      color\n      userIds\n      users {\n        wUserId\n        firstName\n        lastName\n        email {\n          email\n        }\n        channels {\n          wChannelId\n          id\n        }\n        id\n      }\n      id\n    }\n    member {\n      groupChat\n      id\n      externalId\n      externalProfile\n      inboxProfile {\n        firstName\n        lastName\n        name\n        profilePicUrl\n      }\n      liveChat\n    }\n    externalId\n    wMemberId\n    wChannelId\n    wChannel {\n      name\n      integrationIcon\n      integrationName\n      integrationId\n      environments\n      wChannelId\n      wAppId\n      supportedMediaTypes {\n        audio {\n          codec\n          type\n        }\n      }\n      evaluatedRoleBasedConfig {\n        SEND_MESSAGE_ALL\n        SEND_ATTACHMENT\n        SEND_AUDIO\n        TRANSFER_TO_UNASSOCIATED_FOLDERS\n      }\n      id\n    }\n    inputActions {\n      integrationIcon\n      integrationName\n      integrationDescription\n      integrationId\n      integrationBuild\n      iframeContext {\n        payload\n        signedContext\n      }\n      contextToken\n      customActions {\n        url\n        body\n        headers\n        method\n        description\n        modalSchema\n        modalView\n        title\n        type\n        modalWidth\n      }\n    }\n    views {\n      id\n      title\n      type\n      url\n      height\n      placements\n      context\n      width\n      iframeContext {\n        payload\n        signedContext\n      }\n      contextToken\n    }\n    resourceTemplates(for: [\"BOT\", \"MEMBER\"]) {\n      _id\n      preview\n      replyToPreview\n      alias\n      for\n    }\n    wUserId\n    user {\n      wUserId\n      email {\n        email\n        verified\n      }\n      firstName\n      lastName\n      id\n    }\n    etag\n    chats(last: 10, first: 0) {\n      edges {\n        node {\n          _id\n          threadId\n          messageEvent\n          replyToMessageEvent\n          createdAt\n          deliveredAt\n          failedAt\n          readAt\n          sentAt\n          from\n          internal\n          wUserId\n          error\n          mentions {\n            wUserId\n            firstName\n            lastName\n            email {\n              email\n            }\n            id\n          }\n          agent {\n            name\n            icon\n            id\n          }\n          user {\n            profilePic\n            email {\n              email\n            }\n            id\n          }\n          meta\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n      }\n    }\n    id\n  }\n  foldersForThread(threadId: $threadId) @skip(if: $withoutThreadId) {\n    folderId\n    name\n    id\n  }\n  usersForThread(threadId: $threadId) @skip(if: $withoutThreadId) {\n    wUserId\n    firstName\n    lastName\n    profilePic\n    email {\n      email\n    }\n    id\n  }\n  role\n  id\n}\n\nfragment Folders_userViewer on UserScope {\n  folders {\n    folderId\n    name\n    color\n    isPrivate\n    userIds\n    unreadThreadCount\n    id\n  }\n  role\n  id\n}\n\nfragment GlobalThreads_userViewer on UserScope {\n  role\n  id\n}\n\nfragment Inbox_folderThreadsViewer_anm0i on UserScope {\n  threads(folderIds: [$folderId], first: 1) {\n    pageInfo {\n      totalCount\n    }\n  }\n  id\n}\n\nfragment Inbox_navHintViewer_45Y6Ci on UserScope {\n  id\n}\n\nfragment Inbox_userViewer_anm0i on UserScope {\n  configuration {\n    member {\n      tags\n    }\n    id\n  }\n  mentions(first: 1000, unreadOnly: true) {\n    edges {\n      node {\n        _id\n        readAt\n        id\n      }\n    }\n  }\n  folder(folderId: $folderId) {\n    folderId\n    name\n    color\n    wChannelIds\n    wChannels {\n      name\n      integrationIcon\n      integrationName\n      id\n    }\n    isPrivate\n    userIds\n    default\n    id\n  }\n  role\n  folderActions(folderId: $folderId) {\n    integrationIcon\n    integrationName\n    integrationDescription\n    integrationId\n    integrationBuild\n    iframeContext {\n      payload\n      signedContext\n    }\n    contextToken\n    channel {\n      _id\n      description\n      name\n      type\n      environments {\n        webhooks\n        webhooksV2 {\n          integrationId\n        }\n      }\n    }\n    customActions {\n      url\n      body\n      headers\n      method\n      description\n      modalSchema\n      modalView\n      modalWidth\n      modalHeight\n      title\n      type\n    }\n  }\n  disableNotifications\n  wAppId\n  wUserId\n  id\n}\n\nfragment MemberContainer_userViewer_1f9ovh on UserScope {\n  configuration {\n    member {\n      tags\n    }\n    id\n  }\n  thread(threadId: $threadId) @skip(if: $withoutThreadId) {\n    member {\n      id\n      groupChat\n      wMemberId\n      wChannelId\n      wChannel {\n        name\n        integrationId\n        integrationIcon\n        integrationName\n        id\n      }\n      wAppId\n      externalId\n      externalProfile\n      inboxProfile {\n        firstName\n        lastName\n        website\n        company\n        profilePicUrl\n        dob {\n          date\n          month\n          year\n        }\n        gender\n        locale\n        phones {\n          number\n          alias\n        }\n        emails {\n          email\n          alias\n        }\n        addresses {\n          alias\n          line1\n          line2\n          city\n          state\n          country\n          zip\n        }\n      }\n      tags\n      liveChat\n      meta\n      notes {\n        _id\n        content\n        updatedAt\n        authorId\n        author {\n          email {\n            email\n          }\n          id\n        }\n        etag\n        id\n      }\n      etag\n    }\n    id\n  }\n  role\n  wUserId\n  id\n}\n\nfragment Threads_userViewer on UserScope {\n  role\n  threads(search: \"\", folderIds: [\"main\"], first: 30, assigned: false, onlyUnread: false, sortBy: \"lastChatAt\", sortOrder: \"desc\") {\n    edges {\n      node {\n        threadId\n        folderId\n        folder {\n          folderId\n          name\n          color\n          id\n        }\n        wMemberId\n        wChannelId\n        wChannel {\n          name\n          integrationIcon\n          integrationName\n          id\n        }\n        etag\n        title\n        updatedAt\n        lastChatAt\n        lastMessage\n        lastReadAt\n        unreadCount\n        member {\n          groupChat\n          meta\n          externalId\n          externalProfile\n          inboxProfile {\n            firstName\n            lastName\n            name\n            profilePicUrl\n          }\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      totalCount\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

node.hash = "bcd5e5f9e58e945a64fe4ffc75eeaa92";

module.exports = node;
